var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(
                "Ancient Treasure Bundle (" + _vm._s(this.rules.name) + ")"
              ),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-4 pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    directives: [
                      { name: "ascii-only", rawName: "v-ascii-only" },
                    ],
                    staticClass: "mr-2",
                    attrs: { label: "Name" },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "model.name",
                    },
                  }),
                  _c("v-text-field", {
                    directives: [
                      { name: "ascii-only", rawName: "v-ascii-only" },
                    ],
                    attrs: { label: "Key" },
                    model: {
                      value: _vm.model.key,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model,
                          "key",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "model.key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "r-panel",
                    { attrs: { title: "Settings" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Icon Badge Expires",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.model.iconBadgeExpires,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "iconBadgeExpires",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "model.iconBadgeExpires",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Icon Tooltip Reset",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.model.iconTooltipReset,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "iconTooltipReset",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "model.iconTooltipReset",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("r-guard-panel", {
                    attrs: { model: _vm.model.guard, title: "Guard Config" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guard", $event)
                      },
                    },
                  }),
                  _c("r-guard-money-panel", {
                    attrs: {
                      model: _vm.model.guardMoney,
                      title: "Guard Money",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guardMoney", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "5", md: "5" } },
                    [
                      _c("r-currency-kind-dropdown", {
                        staticClass: "mr-2",
                        attrs: {
                          model: _vm.model.currency_chest,
                          label: "Chest Currency",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "currency_chest", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "5", md: "5" } },
                    [
                      _c("r-currency-kind-dropdown", {
                        attrs: {
                          model: _vm.model.currency_progress,
                          label: "Progress Currency",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "currency_progress",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2", md: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Free keys", "hide-details": "" },
                        model: {
                          value: _vm.model.freeKeys,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "freeKeys", _vm._n($$v))
                          },
                          expression: "model.freeKeys",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-product-dropdown", {
                        attrs: {
                          model: _vm.model.product,
                          groups: _vm.groups_product,
                          label: "Premium Product",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "product", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-item-dropdown", {
                        attrs: {
                          model: _vm.model.statue_item,
                          label: "Statue Item",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "statue_item", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-1", attrs: { dense: "" } },
                [
                  _c("v-card-title", { staticClass: "blue--text" }, [
                    _vm._v("Rewards Tracks"),
                  ]),
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-reward-bunch-panel", {
                        attrs: {
                          model: _vm.model.rewards,
                          title: "Default",
                          label: "Reward",
                          points: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "rewards", $event)
                          },
                        },
                      }),
                      _c("r-reward-bunch-panel", {
                        attrs: {
                          model: _vm.model.rewards_premium,
                          title: "Premium",
                          label: "Reward",
                          points: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "rewards_premium",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-card-title", { staticClass: "orange--text" }, [
                    _vm._v("Chests Tracks"),
                  ]),
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-reward-bunch-panel", {
                        attrs: {
                          model: _vm.model.chests,
                          title: "Default",
                          label: "Chests",
                          points: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "chests", $event)
                          },
                        },
                      }),
                      _c("r-reward-bunch-panel", {
                        attrs: {
                          model: _vm.model.chests_optional,
                          title: "Optional",
                          label: "Chest Optional",
                          points: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "chests_optional",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-card-title", { staticClass: "green--text" }, [
                    _vm._v("Exchange"),
                  ]),
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-ancient-treasure-exchange-config", {
                        attrs: { model: _vm.model.exchangeConfig },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "exchangeConfig", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }